import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import React from 'react'

export const documentCaptionIndex =
  (index: number): NodeRenderer =>
  (node, children) => (
    <div className="text-075 text-amplification-black-premium group-[.is-dark]/theme:text-white-50">
      <span className="text-amplification-iconic">({index + 1})</span>{' '}
      {children}
    </div>
  )
